const SECOND_MS = 1000
const MINUTE_MS = 60 * SECOND_MS
const SECONDS_PER_MINUTE = 60
const MAX_PERCENT = 100

export const formatCountdown = (milliseconds) => {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / SECOND_MS))
    const minutes = Math.floor(totalSeconds / SECONDS_PER_MINUTE)
    const seconds = String(totalSeconds % SECONDS_PER_MINUTE).padStart(2, '0')

    return `${minutes}:${seconds}`
}

export const minutesUntil = (timestamp, now) => Math.ceil((timestamp - now) / MINUTE_MS)

export const formatHour = (timestamp) => {
    const date = new Date(timestamp)
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')

    return `${hours}:${minutes}`
}

export const remainingPercent = (startedAt, endsAt, now) => {
    if (!startedAt || !endsAt || endsAt <= startedAt) {
        return 0
    }
    const percent = ((endsAt - now) / (endsAt - startedAt)) * MAX_PERCENT

    return Math.min(MAX_PERCENT, Math.max(0, percent))
}

export const elapsedPercent = (startedAt, endsAt, now) => {
    if (!startedAt || !endsAt) {
        return 0
    }
    return MAX_PERCENT - remainingPercent(startedAt, endsAt, now)
}
